import React, { useEffect, useState } from 'react';
import { Grid } from '@mui/material';
import { useHistory } from 'react-router-dom';
import NewPage from '../components/NewPage';
import RobotRegisterContainer from '../containers/manage/RobotRegisterContainer';
import RobotDeleteContainer from '../containers/manage/RobotDeleteContainer';
import { getUserRole } from '../common/util';

const ManagePage = () => {
  const history = useHistory();
  const role = getUserRole();
  const [rights, setRights] = useState([false, false]);

  useEffect(() => {
    let bAdd = false;
    let bDel = false;
    const n = role && Number(role.substr(0, 1));
    if (n > 3) {
      bDel = true;
    }
    if (n > 1) {
      bAdd = true;
    }
    setRights([bAdd, bDel]);
    if (!(bAdd || bDel)) {
      history.replace('/');
    }
  }, [role]);

  return (
    <NewPage title="관리자 로봇 관리">
      {rights[0] && (
        <Grid item xs={12} md={6}>
          <RobotRegisterContainer />
        </Grid>
      )}
      {rights[1] && (
        <Grid item xs={12} md={6}>
          <RobotDeleteContainer />
        </Grid>
      )}
    </NewPage>
  );
};

export default ManagePage;
